import _ from 'lodash';
import globalStore from '$$globalStore';
import constants from '$$helpers/constants';
import projectsModel from '$$projectModel';
import createWorker from './createWorker';

class ProgressWorker {
  #worker = null;

  #filterGanttIds = [];

  #dataComposers = {
    changeTasks: data => {
      const ganttIdsMap = {};
      const preparedData = {};

      data.forEach(taskChangeData => {
        const ganttId = taskChangeData.gantt_id;

        ganttIdsMap[ganttId] = true;

        if (!preparedData[ganttId]) preparedData[ganttId] = [];

        preparedData[ganttId].push(taskChangeData);
      });

      this.#filterGanttIds = Object.keys(ganttIdsMap);

      return preparedData;
    },

    recalcTasks: ganttId => {
      this.#filterGanttIds = [ganttId];
    },
  };

  constructor() {
    this.#initWorker();
  }

  #initWorker() {
    let version = Date.now();

    if (GT.productVersion && GT.productVersion.buildVersion) {
      version = GT.productVersion.buildVersion;
    }

    this.#worker = createWorker(`/workers/progress_worker.js?${version}`);
  }

  #prepareModelsData() {
    const resultData = {
      progressTypes: {},
      ganttTasks: {},
      statuses: {},
      constants: {
        TASK_TYPES: constants.TASK_TYPES,
        PROGRESS_TYPES: constants.PROGRESS_TYPES,
      },
    };

    this.#filterGanttIds.forEach(ganttId => {
      resultData.progressTypes[ganttId] = projectsModel.getProjectConfig(+ganttId)?.progress || 'duration';;
      resultData.ganttTasks[ganttId] = globalStore.getters['tasksModel/getTasksForGantt'](+ganttId)?.data || [];
      resultData.statuses[ganttId] = globalStore.getters['columns/getColumnByName']('status', +ganttId)?.options || [];
    });

    return resultData;
  }

  async calculate(data, composer, action) {
    this.#filterGanttIds = [];

    const updatedData = this.#dataComposers[composer](data);
    const innerData = this.#prepareModelsData();

    const calculatedData = await this.#worker(_.cloneDeep({
      innerData,
      updatedData,
      action: action || composer,
    }));

    return Promise.resolve(calculatedData);
  }
}

export default new ProgressWorker();
